module.exports = __webpack_public_path__ + "static/img/Max-McCarthy.6d5be69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max-McCarthy.jpg
// module id = nrk5
// module chunks = 0